export function formDataGenerator<Body extends Record<string, unknown>>(
  body?: Body,
): FormData {
  const formData = new FormData();

  if (body === undefined) {
    return formData;
  }

  Object.entries(body).forEach(([key, value]) => {
    appendEntry(formData, key, value);
  });

  return formData;
}

function appendEntry(form: FormData, key: string, value: unknown) {
  if (value === undefined) {
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((v) => appendEntry(form, key, v));
  } else if (value instanceof Blob || typeof value === "string") {
    form.append(key, value);
  } else {
    const valueBlob = new Blob([JSON.stringify(value)], {
      type: "application/json",
    });
    form.append(key, valueBlob);
  }
}
